const VALID_THEMES = ['light', 'dark', 'colorblind'] as const;
type Theme = (typeof VALID_THEMES)[number];

function applyTheme(theme: Theme): void {
    const link = document.getElementById('theme-css') as HTMLLinkElement | null;
    if (link) link.href = `/assets/css/theme-${theme}.css`;

    document.querySelectorAll<HTMLElement>('.theme-btn').forEach((btn) => {
        btn.classList.toggle('active', btn.dataset.theme === theme);
    });

    document.cookie = `mm-theme=${theme};path=/;max-age=31536000;SameSite=Lax`;
}

document.querySelectorAll<HTMLElement>('.theme-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
        const theme = btn.dataset.theme as Theme;
        if (VALID_THEMES.includes(theme)) applyTheme(theme);
    });
});
